import React from 'react';
import * as PropTypes from 'prop-types';
import PlusCircleIcon from '@heroicons/react/24/outline/PlusCircleIcon';

const InvitationButton = ({ onClick, children }) => (
  <button
    type="button"
    className="flex bg-slate-50 p-4 text-blue-500 border-t border-slate-300 hover:bg-slate-100 items-center"
    onClick={onClick}
  >
    <PlusCircleIcon className="mr-4 h-7 w-7" />
    <div>{children}</div>
  </button>
);

InvitationButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default InvitationButton;
